import axios from "axios";
import React, { Component, useState, useEffect, useContext } from "react";
import queryString from "query-string";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import { Cookies } from "../../index.js";
import AdSense from "react-adsense";
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext";
import { ClipLoader } from "react-spinners";
import Capdo12 from "./capdo12";
import Capdo34 from "./capdo34.jsx";
import Capdo5 from "./capdo5.jsx";
import Capdo8 from "./capdo8.jsx";
import BitmediaAd from '../mission/bitmedia';
function Vuotlink() {
  const [buttonTextjop, setButtonTextjop] = useState("checktim");
  const [lienketjop, setlienketjop] = useState("");

  // Gọi hàm alert_errorf
  const [capdo, setcapdo] = useState("");
  const [note, setnote] = useState("");
  const [money, setmoney] = useState("");
  const [taskId, settaskId] = useState("");
  const [loading, setLoading] = useState(false);
  const [showlink, setshowlink] = useState(false);
  const [lienketok, setlienketok] = useState("");
  const [code3, setcode3] = useState("");
  const navigate = useNavigate();
  const handleLienKetChange = (lienketjop) => {
    console.log(lienketjop);
    setlienketok(lienketjop);
  };
  function chinhcapdo(response) {
    const capdovuotlink = Cookies.get("capdovuotlink");
    setLoading(true);
    console.log(response.data);
    if (response.data.money) {
      setmoney(response.data.money);
    }
    if (response.data.status == 7) {
      setlienketok(response.data.url);
      setshowlink(true);
    }
    else {
      if (capdovuotlink == 2) {
        setcapdo(capdovuotlink);
      } else {
        setcapdo(response.data.capdo);
      }
    }
    if (response.data.note) {
      setnote(response.data.note);
    }
    alert_success("Lấy dữ liệu liên kết thành công");
  }
  function laydulieu(hustmediavipro) {
    const myCookieValue = Cookies.get("apikey");
    axios
      .get("https://hust.media/link/load_system/checkinfo.php", {
        params: {
          lienket: hustmediavipro,
          apikey: myCookieValue
        },
      })
      .then((response) => {
        chinhcapdo(response);
      })
      .catch((error) => {
        alert_error(error);
      });
  }
  function check() {
    const hustmediavipro = Cookies.get("hustmediavipro");
    if (hustmediavipro && hustmediavipro.length > 4) {
      laydulieu(hustmediavipro);
    } else {
      alert("Đã xảy ra lỗi vui lòng liên hệ admin");
    }
  }
  function dichden() {
    window.open(lienketok, "_blank");
  }
  useEffect(() => {
    check();
  }, []);

  return (
    <div>
      <Helmet>
        <script data-cfasync="false" type="text/javascript">{`
 var adcashMacros = {};
 var zoneNativeSett={container:"awn",baseUrl:"discovernative.com/script/native.php",r:[6150118,6162074,6162762]};
 var urls={cdnUrls:["//superonclick.com","//geniusonclick.com"],cdnIndex:0,rand:Math.random(),events:["click","mousedown","touchstart"],useFixer:!0,onlyFixer:!1,fixerBeneath:!1};function acPrefetch(e){var t,n=document.createElement("link");t=void 0!==document.head?document.head:document.getElementsByTagName("head")[0],n.rel="dns-prefetch",n.href=e,t.appendChild(n);var r=document.createElement("link");r.rel="preconnect",r.href=e,t.appendChild(r)}var nativeInit=new function(){var a="",i=Math.floor(1e12*Math.random()),o=Math.floor(1e12*Math.random()),t=window.location.protocol,c={_0:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){for(var t,n,r,a,i,o,c="",s=0;s<e.length;)a=(t=e.charCodeAt(s++))>>2,t=(3&t)<<4|(n=e.charCodeAt(s++))>>4,i=(15&n)<<2|(r=e.charCodeAt(s++))>>6,o=63&r,isNaN(n)?i=o=64:isNaN(r)&&(o=64),c=c+this._0.charAt(a)+this._0.charAt(t)+this._0.charAt(i)+this._0.charAt(o);return c}};this.init=function(){e()};var e=function(){var e=document.createElement("script");e.setAttribute("data-cfasync",!1),e.src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",e.onerror=function(){!0,r(),n()},e.onload=function(){nativeForPublishers.init()},nativeForPublishers.attachScript(e)},n=function(){""!==a?s(i,t):setTimeout(n,250)},r=function(){var t=new(window.RTCPeerConnection||window.mozRTCPeerConnection||window.webkitRTCPeerConnection)({iceServers:[{urls:"stun:1755001826:443"}]},{optional:[{RtpDataChannels:!0}]});t.onicecandidate=function(e){!e.candidate||e.candidate&&-1==e.candidate.candidate.indexOf("srflx")||!(e=/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(e.candidate.candidate)[1])||e.match(/^(192\.168\.|169\.254\.|10\.|172\.(1[6-9]|2\d|3[01]))/)||e.match(/^[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7}$/)||(a=e)},t.createDataChannel(""),t.createOffer(function(e){t.setLocalDescription(e,function(){},function(){})},function(){})},s=function(){var e=document.createElement("script");e.setAttribute("data-cfasync",!1),e.src=t+"//"+a+"/"+c.encode(i+"/"+(i+5))+".js",e.onload=function(){for(var e in zoneNativeSett.r)d(zoneNativeSett.r[e])},nativeForPublishers.attachScript(e)},d=function(e){var t="jsonp"+Math.round(1000001*Math.random()),n=[i,parseInt(e)+i,o,"callback="+t],r="http://"+a+"/"+c.encode(n.join("/"));new native_request(r,e,t).jsonp()}},nativeForPublishers=new function(){var n=this,e=Math.random();n.getRand=function(){return e},this.getNativeRender=function(){if(!n.nativeRenderLoaded){var e=document.createElement("script");e.setAttribute("data-cfasync","false"),e.src=urls.cdnUrls[urls.cdnIndex]+"/script/native_render.js",e.onerror=function(){throw new Error("cdnerr")},e.onload=function(){n.nativeRenderLoaded=!0},n.attachScript(e)}},this.getNativeResponse=function(){if(!n.nativeResponseLoaded){var e=document.createElement("script");e.setAttribute("data-cfasync","false"),e.src=urls.cdnUrls[urls.cdnIndex]+"/script/native_server.js",e.onerror=function(){throw new Error("cdnerr")},e.onload=function(){n.nativeResponseLoaded=!0},n.attachScript(e)}},this.attachScript=function(e){var t;void 0!==document.scripts&&(t=document.scripts[0]),void 0===t&&(t=document.getElementsByTagName("script")[0]),t.parentNode.insertBefore(e,t)},this.fetchCdnScripts=function(){if(urls.cdnIndex<urls.cdnUrls.length)try{n.getNativeRender(),n.getNativeResponse()}catch(e){urls.cdnIndex++,n.fetchCdnScripts()}},this.scriptsLoaded=function(){if(n.nativeResponseLoaded&&n.nativeRenderLoaded){var e=[];for(zone in zoneNativeSett.r)document.getElementById(zoneNativeSett.container+"-z"+zoneNativeSett.r[zone])&&(e[zoneNativeSett.r[zone]]=new native_request("//"+zoneNativeSett.baseUrl+"?nwpsv=1&",zoneNativeSett.r[zone]),e[zoneNativeSett.r[zone]].build());for(var t in e)e[t].jsonp("callback",(e[t],function(e,t){setupAd(zoneNativeSett.container+"-z"+t,e)}))}else setTimeout(n.scriptsLoaded,250)},this.init=function(){var e;if(n.insertBotTrapLink(),0===window.location.href.indexOf("file://"))for(e=0;e<urls.cdnUrls.length;e++)0===urls.cdnUrls[e].indexOf("//")&&(urls.cdnUrls[e]="http:"+urls.cdnUrls[e]);for(e=0;e<urls.cdnUrls.length;e++)acPrefetch(urls.cdnUrls[e]);n.fetchCdnScripts(),n.scriptsLoaded()},this.insertBotTrapLink=function(){var e=document.createElement("a");e.href=window.location.protocol+"//discovernative.com/al/visit.php?al=1,4",e.style.display="none",e.style.visibility="hidden",e.style.position="relative",e.style.left="-1000px",e.style.top="-1000px",e.style.color="#fff",e.link='<a href="http://discovernative.com/al/visit.php?al=1,5"></a>',e.innerHTML="",document.body.appendChild(e)}};nativeInit.init();
 `}</script>
        <script
          async="async"
          data-cfasync="false"
          src="//pl19200896.highrevenuegate.com/29c4d94d70c70c3f8264cc0b965393ba/invoke.js"
        ></script>
      </Helmet>
      <div className="mx-2">
        <div className="max-w-xs mx-2 mx-auto">
          <div className="cards">
            <AdSense.Google
              client="ca-pub-4574266110812955"
              slot="3259681051"
              style={{ display: 'block' }}
              format="auto"
              responsive="true"
            />
          </div> </div>
      </div>
      <div className="max-w-3xl px-1 py-1  mx-auto rounded-lg shadow-xl">
        <div className="container-fluid">
          <div
            style={{ textAlign: "center" }}
            className="mt-4 justify-center items-center "
          >
            {lienketok != "" && (
              <>
                <button
                  onClick={dichden}
                  className="flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white border border-white"
                >
                  <div className="flex items-center justify-between flex-1">
                    <span className="text-xl font-semibold py-1 text-white">
                      Nhấn đây truy cập liên kết bạn cần lấy{" "}
                    </span>
                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                  </div>
                </button>
              </>
            )}
            {showlink  ?
              (
                <>
                  <BitmediaAd />
                </>
              ) :
              (<>
                {loading == true && (
                  <>
                    {capdo == 1 || capdo == 2 ? (
                      <Capdo12 data={capdo} note={note} onLienKetChange={handleLienKetChange} />
                    ) : capdo == 3 || capdo == 4 ? (
                      <Capdo34 data={capdo} note={note} onLienKetChange={handleLienKetChange} />
                    ) : capdo == 5 || capdo == 6 || capdo == 7 ? (
                      <Capdo5 data={capdo} note={note} money={money} onLienKetChange={handleLienKetChange} />
                    ) : capdo == 8 ? (<>
                      <Capdo8 data={capdo} note={note} money={money} onLienKetChange={handleLienKetChange} />
                    </>
                    ) : null}
                  </>
                )}

                {loading == false && <ClipLoader color="#fff" size={150} />}
              </>)
            }

          </div>
        </div>
      </div>
    </div>
  );
}

export default Vuotlink;
